import { Box, Button, CircularProgress, Stack } from "@mui/material"
import { t } from "i18next"
import React, { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import useSWR from "swr"
import { BackButton } from "~/src/components/atoms/Button/BackButton/BackButton"
import { LinkButton } from "~/src/components/atoms/Button/LinkButton/LinkButton"
import { QuotationDetailList, QuotationDetailSummary, QuotationDetailUser } from "~/src/components/organisms/Quotation"
import { ProtectedPage } from "~/src/components/templates"
import { useUser } from "~/src/hooks/useApi"
import { otherRepository, userRepository } from "~/src/repositories"

export const QuotationDetail: React.FC = (): JSX.Element => {
  const location = useLocation()
  const navigate = useNavigate()
  const { userId } = useParams()
  const [loadingPortId, setLoadingPortId] = useState<Number>(0)
  const { data: user } = useUser(Number(userId))
  const { data: quotations } = useSWR([`/users/${userId}/quotations`], () =>
    userRepository.getQuotatoins(userId)
  )
  const { data: loadingPorts } = useSWR(['/loading-ports'], () =>
    otherRepository.getLoadingPorts()
  )

  useEffect(() => {
    if (user && loadingPorts && loadingPorts.length > 0 && !loadingPortId) { 
      setLoadingPortId(user.user.loadingPortId ?? loadingPorts[0].id)
    }
  }, [loadingPorts, user])

  return (
    <ProtectedPage pageTitle={t('quotation_detail.title')}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <BackButton location={location} />
        <Box>
          <LinkButton
            text={t('quotation_detail.member_details')}
            handleLink={() => 
              navigate(`/admin/member/detail/${userId}`, {
                replace: true,
              })
            }
          />
        </Box>
      </Stack>

      {!user || !quotations || loadingPortId === 0 ? <CircularProgress /> :
        <>
          <Stack direction={'row'} spacing={2} pb={2}>
            <QuotationDetailUser
              user={user.user}
            />
            <QuotationDetailSummary
              data={quotations}
              loadingPortId={loadingPortId}
            />
          </Stack>
          
          <QuotationDetailList
            data={quotations}
            loadingPorts={loadingPorts}
            loadingPortId={loadingPortId}
            changeLoadingId={setLoadingPortId}
          />
        </>
      }

    </ProtectedPage>
  )
}